<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="bg_wrap">
      <topPiece></topPiece>
      <div class="partner_wrap container">
        <titleConfig class="partner_h2" :title="langSet=='cn'?'我们的展商':'Honored Exhibitors'" :type="2"></titleConfig>
        <partner v-if="exhibitorPartnerList.length > 0" :list="exhibitorPartnerList"></partner>
        <titleConfig class="partner_h2" :title="langSet=='cn'?'合作媒体':'Media Partners'" :type="2"></titleConfig>
        <partner v-if="partnerList.length > 0" :list="partnerList"></partner>
      </div>
    </div>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "@/components/top.vue";
import bottom from "@/components/bottom.vue";
import titleConfig from "@/components/title.vue";
import partner from "@/components/partner.vue";
import topPiece from "@/components/topPiece.vue";
import { getPartner, exhibitorPartner } from "@/api/api";
export default {
  // 配置title和meta数据
  metaInfo() {
    return {
      title: this.metaData.name_cn,
      meta: [
        {
          name: "description",
          content: this.metaData.description,
        },
        {
          name: "keywords",
          content: this.metaData.keywords,
        },
      ],
    };
  },
  components: {
    top,
    bottom,
    titleConfig,
    partner,
    topPiece
  },
  data() {
    return {
      langSet: "",
      exhibitorPartnerList: [],
      partnerList: [],
      metaData: {}
    };
  },
  created() {},
  activated() {
    let menuArr = JSON.parse(localStorage.getItem("menuArr"));
    let path = this.$route.fullPath;
    this.metaData = this.findInNestedArray(
      menuArr,
      (item) => item.http_url_cn == path
    );
  },
  mounted() {
    this.langSet = this.$language;
    //25.6.9 获取合作伙伴 dxm
    this.getPartnerList();
    //25.6.9 获取我们的展商 dxm
    this.getExhibitorPartner();
  },
  methods: {
    findInNestedArray(arr, condition) {
      // 使用map遍历外层数组
      const result = arr
        .map((item) => {
          if (condition(item)) return item;

          // 处理嵌套数组
          if (Array.isArray(item.children)) {
            const nestedResult = this.findInNestedArray(
              item.children,
              condition
            );
            if (nestedResult) return nestedResult;
          }
          return null;
        })
        .find((item) => item !== null);

      return result || null;
    },
    async getPartnerList() {
      const res = await getPartner();
      this.partnerList = res.data.lists;
    },
    async getExhibitorPartner(){
      const res = await exhibitorPartner();
      this.exhibitorPartnerList = res.data.lists;
    }
  },
};
</script>
<style lang="scss" scoped>

</style>